import { Id } from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import { convertCrewList } from './shared/convert'
import keys from './shared/keys'
import { CrewListResponse as Response } from './shared/response'
import { CrewListData } from './shared/types'

export function useCrewList(storeId: Id | undefined) {
  const { server } = useServer()
  return useQuery<CrewListData>({
    queryKey: storeId ? keys.list(storeId) : [],
    queryFn: fetchCrewList,
    enabled: !!storeId,
  })

  async function fetchCrewList() {
    if (!storeId) {
      throw new Error('Illegal store ID')
    }

    const response = await server.get<Response.CrewList>(
      `/v2/managers/me/stores/${storeId}/users/summary`
    )

    return convertCrewList(response)
  }
}
